import { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import Box from '@mui/material/Box/Box';
import { useUserStore } from 'store/useUserStore';
import { getAuthUser } from 'store/useUserStore/selectors';

import { ReactComponent as ErrorInfoIcon } from 'assets/icons/ErrorInfoIcon.svg';

import { useToggle } from 'hooks/useToggler';

import { LOGIN_TYPE } from 'interfaces/auth';

import { SectionWrapper } from 'components/_basic/SectionWrapper/SectionWrapper';
import { ChangeEmail } from 'components/ChangeEmail/ChangeEmail';

import styles from './AccountSettings.module.scss';

export const AccountEmail: FC = () => {
  const { t } = useTranslation();
  const userData = useUserStore(getAuthUser);
  const [isModalOpened, setIsModalOpened] = useToggle(false);

  const userLoginType = userData?.loginType;

  const isSocialProvider =
    (userLoginType && userLoginType === LOGIN_TYPE.GOOGLE) || (userLoginType && userLoginType === LOGIN_TYPE.FACEBOOK);

  const openModalHandler = (): void => setIsModalOpened(true);

  return (
    <>
      <SectionWrapper
        sectionTitle={t('email')}
        buttonText={t('change')}
        buttonClickHandler={openModalHandler}
        disabled={Boolean(isSocialProvider)}
      >
        <Box component="p" className={styles.email}>
          <Trans i18nKey="yourEmailAddressIs" email={userData?.email}>
            {t('yourEmailAddress')}{' '}
            <Box component="span" className={styles.emailHighlight}>
              {userData?.email}
            </Box>
          </Trans>
          {isSocialProvider && (
            <Box component="span" className={styles.changeEmailWarning}>
              <ErrorInfoIcon />
              {t('cannotChangeEmailDueToTheSocialProvider')}
            </Box>
          )}
        </Box>
      </SectionWrapper>
      <ChangeEmail isModalOpened={isModalOpened} onModalClose={setIsModalOpened} />
    </>
  );
};
